import { Flex, Heading, Image, Text, VStack } from "@chakra-ui/react";
import { useActiveAccount } from "applesauce-react/hooks";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import RouterLink from "../../components/router-link";

export default function SigninView() {
  const current = useActiveAccount();
  const location = useLocation();

  if (current) return <Navigate to={location.state?.from ?? "/"} replace />;

  return (
    <Flex w="full" minH="100vh" overflowY="auto" justifyContent="center" alignItems="center" px="4" py="10">
      <Flex direction="column" gap="6" maxW="lg" w="full" alignItems="center">
        <VStack as={RouterLink} to="/" spacing="3" mb="2">
          <Image src="/filler/strudel.png" h="120px" objectFit="contain" />
          <Heading size="xl" fontFamily="'Press Start 2P', cursive" fontSize="2xl" textAlign="center">
            litStrudel
          </Heading>
          <Text fontSize="sm" color="gray.500" textAlign="center">
            Sign in to continue
          </Text>
        </VStack>
        <Outlet />
      </Flex>
    </Flex>
  );
}
